import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from '@mui/material';
import NotificationCard from './NotificationCard';
import Service from '../../../../../util/Service';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function NotificationsDialog(props) {
    const {open, setOpen, notificacoes, action } = props;

    const handleClose = () => {
        action();
        setOpen(false);
    };
    function handleAceitarTodas(){
        const dado = {};
        const arr=[]
        for(let x of notificacoes ){
            for( let id of x.ids){
                arr.push( id)
            }
        }
        dado.ids = arr;

        Service.POST("/api/security/not/vistoNotificacoes", dado).then(r =>{
            if( r.success){
                handleClose();
                if( action) action();
            }else{
                alert( r.msg)
            }
        })
    }

    return (

        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Notificações
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Stack direction="row" spacing={2}>
                    {notificacoes && notificacoes.map((row, id) =>
                        <NotificationCard key={"card-"+id} card={row} close={handleClose}/>
                    )}
                    
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleAceitarTodas}>
                    Aceitar todas
                </Button>
            </DialogActions>
        </BootstrapDialog>

    );
}
